import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { Group } from 'STORE/Groups/Group';

import { DefaultDescription } from './DefaultDescription/DefaultDescription';
import { DraftMessageDescription } from './DraftMessageDescription/DraftMessageDescription';
import { useGroupDescriptionPresenter } from './GroupDescription.presenter';
import { LastMessageDescription } from './LastMessageDescription/LastMessageDescription';

interface IGroupDescriptionProps {
  group: Group;
}

export const GroupDescription: FC<IGroupDescriptionProps> = observer(({ group }) => {
  const { t } = useTranslation();

  const presenter = useGroupDescriptionPresenter(group);

  if (group.isShowDraft) {
    return <DraftMessageDescription text={presenter.draftText} />;
  }

  if (!presenter.lastMessage) {
    return <DefaultDescription text={t('chat_list_last_no_messages')} />;
  }

  return (
    <LastMessageDescription
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      name={presenter.sender}
      group={group}
      payload={presenter.payload}
    />
  );
});
